import {ApiModel} from './api-model';

export class Format extends ApiModel {
  blob: string;
  url: string;
  displayUrl: string;
  pictureURL: string;
  pictureId: number;

  constructor(data: any) {
    super(data);
    this.initDisplayUrl();
  }

  get empty() {
    return !(this.url || this.blob || this.displayUrl);
  }

  initDisplayUrl() {
    if (this.displayUrl) {
      return;
    }
    if (this.pictureURL) {
      this.displayUrl = this.pictureURL;
    } else if (this.blob) {
      this.displayUrl = this.blob;
    } else {
      this.displayUrl = null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/models/format.ts